import React from "react";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentIcon from "@mui/icons-material/Payment";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import QuizIcon from "@mui/icons-material/Quiz";
import StoreIcon from '@mui/icons-material/Store';

const menus = [
  {
    label: "sidebar.menu.myBranch",
    type: "section",
    children: [
      {
        uri: "/dashboards/myBranch",
        label: "sidebar.menuItem.myBranch",
        type: "nav-item",
        icon: <StoreIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.purchaseOrder",
    type: "section",
    children: [
      {
        uri: "/dashboards/purchaseOrder",
        label: "sidebar.menuItem.purchaseOrder",
        type: "nav-item",
        icon: <LocalMallOutlinedIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.inventory",
    type: "section",
    children: [
      {
        uri: "/dashboards/inventory",
        label: "sidebar.menuItem.inventory",
        type: "nav-item",
        icon: <Inventory2OutlinedIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.salesOrder",
    type: "section",
    children: [
      {
        uri: "/dashboards/salesOrder",
        label: "sidebar.menuItem.salesOrder",
        type: "nav-item",
        icon: <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },

  // {
  //   label: "sidebar.menu.billing",
  //   type: "section",
  //   children: [
  //     {
  //       uri: "/dashboards/billing",
  //       label: "sidebar.menuItem.billing",
  //       type: "nav-item",
  //       icon: <ReceiptIcon sx={{ fontSize: 20 }} />,
  //     },
  //   ],
  // },
  {
    label: "sidebar.menu.payment",
    type: "section",
    children: [
      {
        uri: "/dashboards/payment",

        label: "sidebar.menuItem.payment",
        type: "nav-item",
        icon: <PaymentIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.tickets",
    type: "section",
    children: [
      {
        uri: "/dashboards/tickets",
        label: "sidebar.menuItem.tickets",
        type: "nav-item",
        icon: <DocumentScannerIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.faqs",
    type: "section",
    children: [
      {
        uri: "/dashboards/faqs",
        label: "sidebar.menuItem.faqs",
        type: "nav-item",
        icon: <QuizIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
];

export default menus;
